import PatientSummary from './PatientSummary';

export default PatientSummary;
